// extracted by mini-css-extract-plugin
export default {"section":"Faq_section__3QErM","header":"Faq_header__EhpyF","faq":"Faq_faq__jfFqC","col":"Faq_col__2EZYz","highlight":"Faq_highlight__Mx7iy"};